import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { getBaseUrl } from "../../utils";
import { useNavigate } from "react-router-dom";

const FormTwo = ({ nextStep, handleFormData, values, prevStep }) => {
    // Read the Google email once and immediately clear it from localStorage.
    // Previously it was left in storage indefinitely, so it kept leaking into
    // every later, unrelated signup in the same browser (e.g. a different
    // phone-number signup would still show the last Google account's email).
    const googleEmailRef = useRef(localStorage.getItem("googleEmail") || "");
    useEffect(() => {
        if (googleEmailRef.current) {
            localStorage.removeItem("googleEmail");
        }
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        father_name: "",
        email: googleEmailRef.current,
        dob: "",
        gender: "",
        guardian_name: "",
        guardian_number: "",
    });
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [profileData, setProfileData] = useState(null);
    console.log("token--------->", token);


    useEffect(() => {
        if (!token) {
            setError("Token is missing. Please login again.");
            setLoading(false);
            return;
        }
        const fetchProfileData = async () => {
            try {
                const response = await axios.get(baseUrl + "user_api/getProfileData", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log("response--------->", response.data.results);
                if (response.data.status) {
                    setProfileData(response.data.results);
                } else {
                    setError("Failed to fetch profile data.");
                }
            } catch (error) {
                setError("Error fetching profile data: " + error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchProfileData();
    }, [token]);
    const handleFormDataNEW = (input) => (e) => {
        const value = e.target?.value;
        if (value !== undefined) {
            let formattedValue = value;
            if (input === "name") {
                formattedValue = value
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());
            }
            if (input === "father_name") {
                formattedValue = value
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());
            }
            if (input === "guardian_name") {
                formattedValue = value
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());
            }
            if (input === "dob") {
                const newAge = calculateAge(value);
                setFormData((prevState) => ({
                    ...prevState,
                    [input]: value,
                    age: newAge,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [input]: formattedValue,
                }));
            }
        }
    };


    // Function to calculate age from dob
    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const currentDate = new Date();
        let age = currentDate.getFullYear() - birthDate.getFullYear();
        const month = currentDate.getMonth();
        const day = currentDate.getDate();

        if (month < birthDate.getMonth() || (month === birthDate.getMonth() && day < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    // Determine if the user is under 18 based on dob
    const age = formData.dob ? calculateAge(formData.dob) : 0;
    const isUnder18 = age < 18;
    const navigate = useNavigate();

    const FormOneSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        if (formData.name) formDataToSend.append("name", formData.name);
        if (formData.father_name) formDataToSend.append("father_name", formData.father_name);
        if (formData.email) formDataToSend.append("email", formData.email);
        if (formData.dob) formDataToSend.append("dob", formData.dob);
        if (formData.gender) formDataToSend.append("gender", formData.gender);
        if (formData.guardian_name) formDataToSend.append("guardian_name", formData.guardian_name);
        if (formData.guardian_number) formDataToSend.append("guardian_number", formData.guardian_number);

        if (formData.profile_img) {
            formDataToSend.append("profile_img", formData.profile_img);
        } else {
            formDataToSend.append("profile_img", "");
        }
        try {
            const response = await axios.patch(baseUrl + "user_api/profileUpdate", formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("API Response:", response.data);
            nextStep();
        } catch (error) {
            console.error("Error in API call:", error);
        }
    };
    const isFormValid = formData.name && formData.father_name && formData.email && formData.dob && formData.gender && (!isUnder18 || (formData.guardian_name && formData.guardian_number));

    useEffect(() => {
        if (profileData) {
            setFormData((prevState) => ({
                ...prevState,
                name: profileData.name || "",
                father_name: profileData.father_name || "",
                email: profileData.email || googleEmailRef.current || "",
                dob: profileData.dob || "",
                gender: profileData.gender || "",
                guardian_name: profileData.guardian_name || "",
                guardian_number: profileData.guardian_number || "",

            }));
        }
    }, [profileData]);

    const getMaxDOB = () => {
        const maxYear = new Date().getFullYear() - 12;
        return `${maxYear}-12-31`; // ✅ Allow entire year
    };

    return (
        <div className=" pt-12">
            <section>
                <div className="container-xxl">
                    <div className="grid grid-cols-1 md:grid-cols-2 bg-[#F2F2F2] px-4 md:px-[30px] pb-44 rounded-[20px] gap-6">
                        <div className="md:mt-0 mt-6">
                            <div className="bg-[#FFFFFF] pt-[60px] p-8 rounded-[15px] h-full">
                                <div className="flex items-center justify-center pb-[50px] ">
                                    <img
                                        src="/assates/Logo__newimage.png"
                                        alt="images"
                                        className="w-[160px]"
                                    />
                                </div>
                                <div className="h-full">
                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <img src="/assates/father_name.svg" alt="images" />
                                            </div>
                                            <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                        </div>
                                        <div>
                                            <h4 className="font-[700] Paragraph__etxt ">
                                                Your Details
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Provide your details to create
                                                your profile.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <i class="ri-user-location-fill text-[22px] text-[#D0D0D0]"></i>
                                            </div>
                                            <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                        </div>
                                        <div>
                                            <h4 className="font-[700] Paragraph__etxt">
                                                Educational Details
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Fill your Educational Details
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex gap-2">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                <i class="ri-user-location-fill text-[22px] text-[#D0D0D0]"></i>
                                            </div>
                                        </div>
                                        <div className="">
                                            <h4 className="font-[700] Paragraph__etxt">
                                                Address
                                            </h4>
                                            <p className="Paragraph__etxt font-[300]">
                                                Complete Address, City, State, Pincode
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* RIGHT SIDE FORM */}
                        <div className="pt-[70px] Paragraph__etxt flex flex-col justify-between">
                            <div>
                                <h3 className="Header__text font-[700]">
                                    Your Details
                                </h3>
                                <p className="Paragraph__etxt font-[500] pt-1 pb-4">
                                    Provide your details to create your profile
                                </p>
                                <form onSubmit={FormOneSubmit} className="h-full">
                                    <div className="space-y-[30px] h-full">
                                        <div className="md:flex justify-between gap-[20px] space-y-6 md:space-y-0">
                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/Full__Name.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        required
                                                        placeholder="Full Name"
                                                        className="w-full pt-3 pb-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.name}
                                                        onChange={handleFormDataNEW("name")}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/father_name.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="father_name"
                                                        required
                                                        placeholder="Father’s Name"
                                                        className="w-full pt-3 pb-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.father_name}
                                                        onChange={handleFormDataNEW("father_name")}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex justify-between gap-[20px]">
                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/call.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="number"
                                                        required
                                                        placeholder="xxx xxx xxxx"
                                                        className="w-full pt-3 pb-3"
                                                        style={{ outline: "none" }}
                                                        value={profileData ? profileData.number : ""}
                                                        disabled
                                                        onChange={(e) => {
                                                            const val = e.target.value
                                                                .replace(/\D/g, "") // sirf digits rakhega (letters, spaces remove)
                                                                .slice(0, 10); // max 10 digits tak limit karega

                                                            handleFormData("phoneNumber")({
                                                                target: { name: "phoneNumber", value: val },
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/Mail.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        required
                                                        placeholder="Email ID"
                                                        className="w-full pt-3 pb-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.email}
                                                        onChange={handleFormDataNEW("email")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-between gap-[20px]">
                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/Date__images.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="date"
                                                        name="dob"
                                                        required
                                                        placeholder="DD/MM/YYYY"
                                                        className="w-full p-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.dob}
                                                        max={getMaxDOB()}
                                                        onChange={handleFormDataNEW("dob")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="bg-[#FFFFFF] w-[150px] rounded-[15px] flex items-center justify-center">
                                                {age} Y
                                            </div>
                                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/Choose_gander.svg" alt="images" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <select
                                                        required
                                                        placeholder="Choose Gender"
                                                        className="w-full p-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.gender}
                                                        onChange={handleFormDataNEW("gender")}
                                                    >
                                                        <option value="" disabled>
                                                            Choose Gender
                                                        </option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Conditional rendering of Guardian’s Details */}
                                        {isUnder18 && (
                                            <div>
                                                <h1>
                                                    You’re under 18y, Please fill your Guardian’s Details:
                                                </h1>

                                                <div className="flex justify-between gap-[20px]">
                                                    <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div>
                                                            <img src="/assates/Full__Name.svg" alt="images" />
                                                        </div>
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="text"
                                                                name="guardian_name"
                                                                required
                                                                placeholder="Guardian’s Name"
                                                                className="w-full pt-3 pb-3"
                                                                style={{ outline: "none" }}
                                                                value={formData.guardian_name}
                                                                onChange={handleFormDataNEW("guardian_name")}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="bg-[#FFFFFF] w-[150px] rounded-[15px] flex items-center justify-center">
                                                        +91
                                                    </div>

                                                    <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div>
                                                            <img src="/assates/call.svg" alt="images" />
                                                        </div>
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="text"
                                                                name="guardian_number"
                                                                required
                                                                placeholder="XXXX XX XXXX"
                                                                className="w-full pt-3 pb-3"
                                                                style={{ outline: "none" }}
                                                                value={formData.guardian_number}
                                                                onChange={(e) => {
                                                                    const val = e.target.value.replace(/\D/g, "").slice(0, 10);

                                                                    handleFormDataNEW("guardian_number")({
                                                                        target: { name: "guardian_number", value: val },
                                                                    });
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            className={`bg-[#B4B4B4] w-[350px] h-[50px] rounded-[15px] text-white Paragraph__etx ${isFormValid ? 'bg-gray-900' : ''
                                                }`}
                                        >
                                            Continue
                                        </button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default FormTwo;
